import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/hxzg_logo.png';
import _imports_1 from '@/assets/img/icon.png';
const _withScopeId = n => (_pushScopeId("data-v-5e3ff131"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-form"
};
const _hoisted_2 = {
  class: "logo-box logo-right"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "height": "40px"
  },
  alt: ""
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "none"
  }
}, "华夏之光未来栋梁系统", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/"
}, "中和黄埔官网", -1));
const _hoisted_6 = {
  class: "login-box"
};
const _hoisted_7 = {
  style: {
    "margin-right": "0px"
  }
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "login-input"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "62px",
    "margin-bottom": "9px"
  },
  alt: ""
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "欢迎登录", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "desc"
}, "华夏之光未来栋梁系统", -1));
const _hoisted_13 = {
  class: "login-input"
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "62px",
    "margin-bottom": "9px"
  },
  alt: ""
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "欢迎申请账号", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "desc"
}, "华夏之光未来栋梁系统", -1));
const _hoisted_18 = {
  key: 1,
  class: "dialog-overlay"
};
const _hoisted_19 = {
  class: "dialog"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  style: {
    "text-align": "center"
  }
}, "请使用支付宝扫码提交申请费用", -1));
const _hoisted_21 = ["src"];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "position": "absolute",
    "right": "0",
    "bottom": "0",
    "left": "0",
    "height": "44px",
    "font-size": "14px",
    "color": "#666",
    "background-color": "#f7fafe"
  }
}, [/*#__PURE__*/_createElementVNode("p", {
  style: {
    "text-align": "center",
    "line-height": "44px"
  }
}, [/*#__PURE__*/_createTextVNode(" Copyright © 2017 北京中和黄埔教育科技有限公司 版权所有 "), /*#__PURE__*/_createElementVNode("a", {
  href: "http://www.beian.miit.gov.cn"
}, "京ICP备10217101号"), /*#__PURE__*/_createTextVNode(" 京公安网备案1070691号 ")])], -1));
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
import bkImg1 from '@/assets/img/hxzg_bg1.png';
import bkImg2 from '@/assets/img/hxzg_bg2.png';
// import bkImg from '@/assets/img/login_icon2.png';
import { setToken, treeDataTranslate } from '@/common/utils/index';
import { useLoginStore, useLayoutStore } from '@/store';
import LoginController from '@/api/system/LoginController';
// import Register from "@/pages/login/register.vue";
import { DictionaryController } from '@/api/system';
import { useDropdown } from '@/common/hooks/useDropdown';
import PlatformUserApplyController from "../../api/generated/platformUserApplyController";
import QRCode from "qrcode";

import { ref, reactive } from 'vue';
const __default__ = {
  name: 'Login'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const loginForm = ref();
    const loginStore = useLoginStore();
    const layoutStore = useLayoutStore();
    const router = useRouter();
    const imgList = reactive([{
      url: bkImg1
    }, {
      url: bkImg2
    }
    // { url: bkImg3 }
    ]);
    const showRegister = ref(false);
    const dataForm = reactive({
      mobilePhone: '',
      idNumStr: '',
      mobileCode: ''
    });
    const dataRule = {
      mobilePhone: [{
        required: true,
        message: '登录手机号不能为空',
        trigger: 'blur'
      }],
      idNumStr: [{
        required: true,
        message: '专属ID不能为空',
        trigger: 'blur'
      }],
      mobileCode: [{
        required: true,
        message: '手机验证码不能为空',
        trigger: 'blur'
      }]
    };
    const isCounting = ref(false);
    const countdown = ref(0);
    const sendVerificationCode = () => {
      if (isCounting.value) return; // 如果正在倒计时，直接返回
      // 这里可以添加发送验证码的逻辑，例如调用API
      let params = {
        mobile: dataForm.mobilePhone,
        // template: "SMS_491340022",
        // signature: "北京中和黄埔教育科技",
        // template: "SMS_483340010",
        // signature: "中和黄埔",
        template: "SMS_482820424",
        signature: "未来栋梁"
      };
      LoginController.sendSms(params).then(res => {
        if (res.data != null) {
          ElMessage.success('发送成功');
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(e => {
        console.warn(e);
      });
      console.log('发送验证码');
      isCounting.value = true;
      countdown.value = 60;
      const interval = setInterval(() => {
        if (countdown.value > 0) {
          countdown.value--;
        } else {
          clearInterval(interval);
          isCounting.value = false;
        }
      }, 1000);
    };
    const onGetIdNumClick = () => {
      if (isCounting.value) return; // 如果正在倒计时，直接返回
      // 这里可以添加发送验证码的逻辑，例如调用API
      let params = {
        mobile: dataForm.mobilePhone
      };
      LoginController.getIdNumStr(params, {
        showMask: false
      }).then(res => {
        dataForm.idNumStr = res.data;
      }).catch(e => {
        console.warn(e);
      });
    };
    const dataFormSubmit = () => {
      loginForm.value?.validate(valid => {
        if (valid) {
          login();
        }
      });
    };
    const toRegister = () => {
      showRegister.value = true;
      showQRCodeDialog.value = false;
    };
    const login = function (verifyParams = null) {
      let params = {
        loginName: dataForm.mobilePhone,
        idNumStr: dataForm.idNumStr,
        mobileCode: dataForm.mobileCode,
        // password: encrypt(dataForm.password),
        captchaVerification: verifyParams?.captchaVerification
      };
      setToken(null);
      LoginController.login(params).then(data => {
        //console.log('login >>>', data);
        if (data.data.menuList) {
          layoutStore.setMenuList(treeDataTranslate(data.data.menuList, 'menuId', 'parentId'));
          delete data.data.menuList;
        }
        setToken(data.data.tokenData);
        layoutStore.setCurrentMenu(null);
        layoutStore.clearAllTags();
        if (data.data.tokenData) {
          delete data.data.tokenData;
        }
        loginStore.setUserInfo(data.data);
        // 登录成功跳转页面
        router.replace({
          name: 'main'
        });
      }).catch(e => {
        console.error(e);
      });
    };
    //注册代码
    const registerForm = ref();
    const registerDataForm = reactive({
      applyUserName: '',
      applyUserMobile: '',
      applyUserType: ''
    });
    const registerDataRule = {
      applyUserName: [{
        required: true,
        message: '申请姓名不能为空',
        trigger: 'blur'
      }],
      applyUserMobile: [{
        required: true,
        message: '申请手机号不能为空',
        trigger: 'blur'
      }],
      applyUserType: [{
        required: true,
        message: '手机验证码不能为空',
        trigger: 'blur'
      }]
    };
    const toLogin = () => {
      showRegister.value = false;
    };
    const dataFormRegister = () => {
      registerForm.value?.validate(valid => {
        if (valid) {
          register();
        }
      });
    };
    const showQRCodeDialog = ref(false);
    const qrCodeImage = ref('');
    const register = async function (verifyParams = null) {
      let params = {
        platformUserApplyDto: {
          applyUserName: registerDataForm.applyUserName,
          applyUserMobile: registerDataForm.applyUserMobile,
          applyUserType: registerDataForm.applyUserType
        }
      };
      PlatformUserApplyController.add(params).then(async data => {
        ElMessage.success("申请提交成功");
        if (registerDataForm.applyUserType == '1902648514274398208') {
          const url = await QRCode.toDataURL(data.data);
          qrCodeImage.value = url;
          showQRCodeDialog.value = true;
        } else {
          showRegister.value = false;
        }
      }).catch(e => {
        console.error(e);
      });
    };
    /**
     * 用户身份下拉数据获取函数
     */
    const loadPlatformUserTypeDropdownList = () => {
      return new Promise((resolve, reject) => {
        const params = {
          effectiveScope: undefined
        };
        DictionaryController.dictPlatformUserType(params).then(res => {
          resolve({
            dataList: res.getList()
          });
        }).catch(e => {
          reject(e);
        });
      });
    };
    // 用户身份配置参数
    const platformUserTypeOptions = {
      loadData: loadPlatformUserTypeDropdownList,
      isTree: false
    };
    // 用户身份下拉组件
    const platformUserTypeWidget = useDropdown(platformUserTypeOptions);
    const {
      dropdownList: platformUserTypeWidgetDropdownList
    } = platformUserTypeWidget;
    return (_ctx, _cache) => {
      const _component_el_space = _resolveComponent("el-space");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createVNode(_component_el_space, {
        direction: "horizontal"
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        src: _unref(bkImg1),
        style: {
          "height": "600px",
          "width": "auto"
        }
      }, null, 8, _hoisted_8)]), _withDirectives(_createElementVNode("div", _hoisted_9, [_hoisted_10, _hoisted_11, _hoisted_12, _createVNode(_component_el_form, {
        model: _unref(dataForm),
        rules: dataRule,
        "label-position": "top",
        ref_key: "loginForm",
        ref: loginForm,
        onKeyup: _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "mobilePhone",
            label: "",
            style: {
              "margin-top": "48px",
              "margin-bottom": "25px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).mobilePhone,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(dataForm).mobilePhone = $event),
              style: {
                "width": "100%"
              },
              placeholder: "登录手机号",
              onKeydown: _cache[1] || (_cache[1] = _withKeys($event => dataFormSubmit(), ["enter"]))
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "idNumStr",
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).idNumStr,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(dataForm).idNumStr = $event),
              style: {
                "width": "60%"
              },
              placeholder: "专属ID",
              readonly: "",
              onKeydown: _cache[3] || (_cache[3] = _withKeys($event => dataFormSubmit(), ["enter"]))
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              class: "login-btn-submit",
              type: "primary",
              size: "large",
              disabled: _unref(isCounting),
              onClick: onGetIdNumClick,
              style: {
                "width": "auto",
                "margin-top": "auto",
                "margin-left": "auto"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(" 点击获取专属ID ")]),
              _: 1
            }, 8, ["disabled"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "mobileCode",
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).mobileCode,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(dataForm).mobileCode = $event),
              style: {
                "width": "65%"
              },
              placeholder: "请输入手机验证码",
              onKeydown: _cache[5] || (_cache[5] = _withKeys($event => dataFormSubmit(), ["enter"]))
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              class: "login-btn-submit",
              type: "primary",
              size: "large",
              disabled: _unref(isCounting),
              onClick: sendVerificationCode,
              style: {
                "width": "auto",
                "margin-top": "auto",
                "margin-left": "auto"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(isCounting) ? `${_unref(countdown)}秒后重试` : '发送验证码'), 1)]),
              _: 1
            }, 8, ["disabled"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "login-btn-submit",
          type: "primary",
          size: "large",
          onClick: _cache[6] || (_cache[6] = $event => dataFormSubmit()),
          style: {
            "width": "100%",
            "margin-top": "48px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(" 登录 ")]),
          _: 1
        }), _createVNode(_component_el_space, {
          direction: "horizontal",
          style: {
            "justify-content": "center",
            "width": "100%",
            "margin-top": "12px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_text, {
            class: "mx-1"
          }, {
            default: _withCtx(() => [_createTextVNode("没有账号，")]),
            _: 1
          }), _createVNode(_component_el_link, {
            type: "primary",
            style: {
              "font-size": "14px"
            },
            onClick: _cache[7] || (_cache[7] = $event => toRegister())
          }, {
            default: _withCtx(() => [_createTextVNode("立即申请账号")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "onKeyup"])], 512), [[_vShow, !_unref(showRegister)]]), _withDirectives(_createElementVNode("div", _hoisted_13, [!_unref(showQRCodeDialog) ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_hoisted_15, _hoisted_16, _hoisted_17, _createVNode(_component_el_form, {
        model: _unref(registerDataForm),
        rules: registerDataRule,
        gutter: 20,
        "label-position": "top",
        ref_key: "registerForm",
        ref: registerForm,
        onKeyup: _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "applyUserName",
            label: "",
            style: {
              "margin-top": "48px",
              "margin-bottom": "25px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(registerDataForm).applyUserName,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(registerDataForm).applyUserName = $event),
              style: {
                "width": "100%"
              },
              placeholder: "姓名",
              onKeydown: _cache[9] || (_cache[9] = _withKeys($event => dataFormRegister(), ["enter"]))
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "applyUserMobile",
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(registerDataForm).applyUserMobile,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(registerDataForm).applyUserMobile = $event),
              style: {
                "width": "100%"
              },
              placeholder: "手机号",
              onKeydown: _cache[11] || (_cache[11] = _withKeys($event => dataFormRegister(), ["enter"]))
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "applyUserType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              class: "custom-select",
              modelValue: _unref(registerDataForm).applyUserType,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(registerDataForm).applyUserType = $event),
              placeholder: "申请身份(必选)",
              clearable: true,
              filterable: true,
              onVisibleChange: _unref(platformUserTypeWidget).onVisibleChange,
              onKeydown: _cache[13] || (_cache[13] = _withKeys($event => dataFormRegister(), ["enter"]))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(platformUserTypeWidgetDropdownList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "onVisibleChange"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "login-btn-submit",
          type: "primary",
          size: "large",
          onClick: _cache[14] || (_cache[14] = $event => dataFormRegister()),
          style: {
            "width": "100%",
            "margin-top": "48px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(" 申请 ")]),
          _: 1
        }), _createVNode(_component_el_space, {
          direction: "horizontal",
          style: {
            "justify-content": "center",
            "width": "100%",
            "margin-top": "12px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_text, {
            class: "mx-1"
          }, {
            default: _withCtx(() => [_createTextVNode("已有账号，")]),
            _: 1
          }), _createVNode(_component_el_link, {
            type: "primary",
            style: {
              "font-size": "14px"
            },
            onClick: _cache[15] || (_cache[15] = $event => showRegister.value = false)
          }, {
            default: _withCtx(() => [_createTextVNode("立即登录")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "onKeyup"])])) : _createCommentVNode("", true), _unref(showQRCodeDialog) ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("img", {
        src: _unref(qrCodeImage),
        alt: "二维码",
        style: {
          "height": "300px",
          "padding-left": "10%"
        }
      }, null, 8, _hoisted_21)]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        class: "login-btn-submit",
        type: "primary",
        size: "large",
        onClick: _cache[16] || (_cache[16] = $event => toLogin()),
        style: {
          "width": "100%",
          "margin-top": "10px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" 去登录 ")]),
        _: 1
      })])])) : _createCommentVNode("", true)], 512), [[_vShow, _unref(showRegister)]])]), _hoisted_22]);
    };
  }
});